import { render } from "./Demo1.vue?vue&type=template&id=66b715a8"
import script from "./Demo1.vue?vue&type=script&lang=js"
export * from "./Demo1.vue?vue&type=script&lang=js"

import "./Demo1.vue?vue&type=style&index=0&id=66b715a8&lang=css"
script.render = render

export default script